import React, { useState, useEffect } from "react";
import { producaov2 } from "../../../services/apis";
import Dropzone from "../../../components/Admin/Dropzone";
import { toast } from "react-toastify";
import Menu from "../../../components/Admin/MenuDetalhes/AdminMenu";
import { Container, Title, Button } from "./styles";
import "react-toastify/dist/ReactToastify.css";
import { isAuthAdmin } from "../../../services/auth";
import CopyButton from "./CopyButton";
toast.configure();
const UploadsArquivos = () => {
  const [selectedFile, setSelectedFile] = useState("");
  const [url, setUrl] = useState("");

  useEffect(() => {
    loadAuth();
  }, []);

  const loadAuth = async () => {
    const auth = await isAuthAdmin();

    if (!auth) {
      localStorage.setItem("redirect", `/admin/`);
      window.location.href = "/login";
      return null;
    }
  };

  const handleNewUpload = () => {
    setSelectedFile("");
    setUrl("");
  }

  async function handleSubmit(e) {
    e.preventDefault();

    try {
      const inputData = new FormData();

      inputData.append("file", selectedFile);
      inputData.append("path", "anexos");
      inputData.append("categorize", "yes");

      const response = await producaov2.post("/upload", inputData);
      let logs = {
        local: "PaginaUploads",
        texto: `enviou o arquivo (${response.data.url})`,
      };
      producaov2.post("system_logs", { acao: JSON.stringify(logs) });
      const { url } = response.data;

      setUrl(url);

      toast.success("A operação foi concluida com sucesso!", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    } catch (err) {
      toast.error("A operação falhou, verifique o arquivo e tente novamente", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
  }

  return (
    <div style={{width: "100vw", paddingLeft:"250px"}}>

      <Menu />
      <Container>
        <form onSubmit={handleSubmit}>
          <Title>Upload</Title>
          {url && (
            <div>
              <span>
                Link de acesso:
                <a href={url}>
                  <strong>&nbsp;{url}</strong>
                </a>
              </span>
              <CopyButton url={url} />
            </div>
          )}
          <Dropzone key={selectedFile?.name} selectedFile={selectedFile} onFileUploaded={setSelectedFile} />
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '1rem', padding: '1rem' }}>
            <Button type="submit" style={{ margin: 0 }}>Subir o arquivo</Button>
            {!!selectedFile && (
              <Button type="button" title="Subir novo arquivo" bgColor="#ff7417" style={{ margin: 0 }} onClick={handleNewUpload}>Novo Upload</Button>
            )}
          </div>
        </form>
      </Container>
    </div>
  );
};

export default UploadsArquivos;
